<form
  [formGroup]="organization_builder_form_group"
  class="hmn-form__standalone hmn-row__space hmn-wrap">
  <mat-form-field
    class="hmn-width__full hmn-form-field__primary"
    appearance="fill"
    color="accent">
    <mat-label> {{ 'GENERAL.BUSINESS_NAME_LABEL' | translate }} </mat-label>
    <input
      matInput
      type="text"
      formControlName="business_name"
      [errorStateMatcher]="error_matcher"
      required />
  </mat-form-field>

  <mat-form-field
    class="hmn-width__full hmn-form-field__primary"
    appearance="fill"
    color="accent">
    <mat-label> {{ 'GENERAL.VAT_NUMBER_LABEL' | translate }} </mat-label>
    <input
      matInput
      type="text"
      formControlName="vat"
      [errorStateMatcher]="error_matcher"
      required />
  </mat-form-field>

  <mat-form-field
    class="hmn-width__full hmn-form-field__primary"
    appearance="fill"
    color="accent">
    <mat-label> {{ 'GENERAL.WEBSITE_LABEL' | translate }} </mat-label>
    <input
      matInput
      type="text"
      formControlName="website"
      [errorStateMatcher]="error_matcher"
      required />
  </mat-form-field>

  <app-shared-button
    class="hmn-margin__x6-top hmn-display__block hmn-width__full"
    [button_cta]="'GENERAL.CONFIRM_CTA'"
    [button_class]="'hmn-button__main hmn-width__full'"
    [button_cta_class]="'hmn-text__5'"
    (button_click)="onConfirmClick()"></app-shared-button>
</form>
